import styled from 'styled-components';

import type { StyleObject } from './StyleUtils';
import { StyleUtils } from './StyleUtils';

// flex
export const FlexColumn = styled.div(
  StyleUtils.Flex.Column.base as StyleObject & Record<string, string>,
);

export const FlexRow = styled.div(
  StyleUtils.Flex.Row.base as StyleObject & Record<string, string>,
);

export const FlexColumnCenterHorizontal = styled.div(
  StyleUtils.Flex.Column.CenterHorizontal as StyleObject &
    Record<string, string>,
);

export const FlexColumnCenterVertical = styled.div(
  StyleUtils.Flex.Column.CenterVertical as StyleObject & Record<string, string>,
);

export const FlexColumnCenterBoth = styled.div(
  StyleUtils.Flex.Column.CenterBoth as StyleObject & Record<string, string>,
);

export const FlexRowCenterVertical = styled.div(
  StyleUtils.Flex.Row.CenterVertical as StyleObject & Record<string, string>,
);

export const FlexRowCenterHorizontal = styled.div(
  StyleUtils.Flex.Row.CenterHorizontal as StyleObject & Record<string, string>,
);

export const FlexRowCenterBoth = styled.div(
  StyleUtils.Flex.Row.CenterBoth as StyleObject & Record<string, string>,
);

export const FlexRowCenterBaseline = styled.div(
  StyleUtils.Flex.Row.CenterBaseline as StyleObject & Record<string, string>,
);

// grid
export const GridTwoEvenColumns = styled.div(
  StyleUtils.Grid.EvenColumns(2) as StyleObject & Record<string, string>,
);

// legacy

/**
 * A simply div that centers its inner content.
 * This is normally sufficient if the desire is to just center
 * a component in the middle of its view.
 *
 * @deprecated use appropriate Flex components instead
 */
export const CenteredDiv = styled.div`
  text-align: center;
`;

/**
 * A div that is pulled right
 *
 * @deprecated use appropriate Flex components instead
 */
export const RightDiv = styled.div`
  float: right;
  padding-bottom: 5px;
`;

/**
 * Props for ScrollWrapper
 */
interface ScrollWrapperProps extends React.HtmlHTMLAttributes<Element> {
  /** The maximum scroll height, over is overflow */
  maxHeight?: string;
}

/**
 * Wrapper for vertical scroll
 */
export const ScrollWrapper = styled.div<ScrollWrapperProps>`
  ${({ maxHeight }) =>
    maxHeight
      ? `
    max-height: ${maxHeight};
    overflow-y: scroll;
  `
      : ''};
  overflow-x: hidden;
`;
